module.exports = __webpack_public_path__ + "static/img/2969_phase_function_Paper_Points.e0c1cb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2969_phase_function_Paper_Points.png
// module id = K6RW
// module chunks = 0